<div class="shell">
  <header class="shell__header">
    <app-header></app-header>
  </header>
  <div class="shell__main">
    <nav>
      <app-side-nav (menuExpanded)="onMenuSizeChanged($event)"></app-side-nav>
    </nav>
    <main #scrollContainer [class.menu_expanded]="menuExpanded">
      <router-outlet></router-outlet>
      <span class="main-overlay" (click)="mainOverlayClicked()"></span>
      <!--<app-footer></app-footer>-->
    </main>
  </div>
</div>
